const env = window.__ENV__ || {};
//  {
//   BASE_URL: "http://localhost:8080",
//   OKTA_DOMAIN: "https://trial.okta.com",
//   OKTA_CLIENT_ID: "xxxx",
//   OKTA_REDIRECT_URI: "http://localhost:3000/login",
//   PROD_SIGN_IN: "false"
// };
// kept for the reference
export const BASE_URL = env.BASE_URL;
export const OKTA_DOMAIN = env.OKTA_DOMAIN;
export const OKTA_CLIENT_ID = env.OKTA_CLIENT_ID;
export const OKTA_REDIRECT_URI = env.OKTA_REDIRECT_URI;
export const PROD_SIGN_IN = env.PROD_SIGN_IN;

export function getEnv() {
  return {
    BASE_URL,
    OKTA_DOMAIN,
    OKTA_CLIENT_ID,
    OKTA_REDIRECT_URI,
    PROD_SIGN_IN,
  };
}